import { Divider, Row, Col } from "antd";
import styled from "styled-components";

const StyledContainer = styled(Row)`
  @media (max-width: 420px) {
    margin-top: 32px;
  }

  margin-top: 52px;
  display: flex;
  align-items: center;
  .section-divider{
    display: flex;
    align-items: center;
    flex-grow: 1;
  }
`;

const SectionTitle = styled.span`
  font-size: 20px;
  line-height: 16px;
  font-weight: bold;
  color: #707070;
  display: inline-flex;
`;

const StyledDivider = styled(Divider)`
  display: flex;
  height: 1px;
  background-color: var(--primary-main-color);
`;

const SectionHeader = ({ title, classes='' }) => {
  return (
    <StyledContainer align="middle" gutter={16} className={`section-header ${classes}`}>
      <Col className="mragain-section-title">
        <SectionTitle >{title}</SectionTitle>
      </Col>
      <Col className="section-divider">
        <StyledDivider type="horizontal" />
      </Col>
    </StyledContainer>
  );
};

export default SectionHeader;
